import React from "react";
import { Link } from "react-router-dom";

export default function NavLinks({ isReader }) {
  return (
    <nav className="hidden md:flex items-center gap-7 font-display uppercase tracking-[0.18em] text-[0.78rem]">
      <Link
        to="/"
        className="hover:text-[hsl(var(--primary))] transition-colors"
        data-testid="nav-home"
      >
        Home
      </Link>
      <Link
        to="/read"
        className={
          "hover:text-[hsl(var(--primary))] transition-colors " +
          (isReader ? "text-[hsl(var(--primary))]" : "")
        }
        data-testid="nav-read"
      >
        Read the Book
      </Link>
      <a
        href="#signup"
        className="hover:text-[hsl(var(--primary))] transition-colors"
        data-testid="nav-signup"
      >
        Join
      </a>
      <a
        href="#contact"
        className="hover:text-[hsl(var(--primary))] transition-colors"
        data-testid="nav-contact"
      >
        Contact
      </a>
    </nav>
  );
}
